import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  SET_USER_DATA,
  SESSION_STATUS_SET,
  SESSION_PROFILE_SET,
} from "constants/ActionTypes";
import { SESSION_STATUS } from "../../util/session";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  initURL: "",
  authUser: null,
  token: null,
  sessionStatus: SESSION_STATUS.LOADING,
  profile: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        token: null,
        initURL: "/",
        loader: false,
        sessionStatus: SESSION_STATUS.ANONYMOUS,
        profile: null,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }
    case SET_USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
        token: action.payload ? state.token || "cookie-session" : null,
      };
    }
    case SESSION_STATUS_SET: {
      return {
        ...state,
        sessionStatus: action.payload,
        token:
          action.payload === SESSION_STATUS.AUTHENTICATED
            ? state.token || "cookie-session"
            : null,
        authUser:
          action.payload === SESSION_STATUS.AUTHENTICATED
            ? state.authUser || "cookie-session"
            : null,
      };
    }
    case SESSION_PROFILE_SET: {
      return {
        ...state,
        profile: action.payload,
      };
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    default:
      return state;
  }
};
